<template>
  <v-autocomplete
    dense
    :items="oradores"
    :label="i18n(label)"
    :loading="loading"
    :outlined="outlined"
    :autofocus="autofocus"
    :filter="() => true"
    :clearable="true"
    :search-input.sync="search"
    :hide-details="hideDetails"
    class="pt-0"
    :no-data-text="'filter.sync'.translate()"
    v-model="orador"
    @keyup.enter="$emit('on-enter', $event)"
  />
</template>

<script>
import { requests } from '@/plugins/Amplify'
const onlyNumber = (str) => isNaN(str) ? null : Number(str)
const onlyString = (str) => String(str || '').trim()

export default {
  props: {
    value: {},
    label: { default: 'filter.orador' },
    outlined: { default: false },
    autofocus: { default: false },
    hideDetails: { default: true }
  },

  data () {
    return {
      oradores: [],
      search: null,
      loading: false,
      timeout: null,
      orador: onlyNumber(this.value)
    }
  },

  methods: {
    clearTimeout () {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  },

  mounted () {
    if (this.value) {
      requests.getOradores({ id: this.value }).then((data) => {
        if (!data.length) return
        this.oradores = data.map(({ id, nome }) => ({ value: id, text: nome }))
      })
    }
  },

  watch: {
    orador () {
      const orador = onlyNumber(this.orador)
      const changed = orador !== onlyNumber(this.value)
      if (changed) this.$emit('input', orador)
    },

    value () {
      const value = onlyNumber(this.value)
      const changed = value !== onlyNumber(this.orador)
      if (changed) this.orador = value
    },

    search () {
      this.clearTimeout()

      const nome = onlyString(this.search)
      if (!nome || this.oradores.find(({ text }) => text === nome)) {
        this.loading = false
        return
      }

      this.loading = true

      this.timeout = setTimeout(async () => {
        try {
          const data = await requests.getOradores({ nome })
          this.oradores = data.map(({ id, nome }) => ({ value: id, text: nome }))
        } catch (error) {
          console.error(error)
        }

        this.loading = false
      }, 275)
    }
  }
}
</script>
